import { render } from "./unspsc.vue?vue&type=template&id=62a3e806"
import script from "./unspsc.vue?vue&type=script&lang=js"
export * from "./unspsc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__